import { useMsal } from "@azure/msal-react";
import { Avatar, IconButton, Box, Tooltip } from "@mui/material";
import LogoutIcon from "@mui/icons-material/Logout";
import { useEffect, useState } from "react";
import { getAccountByTenantId } from "../utils/accountUtils";

function SignOut() {
  const { instance, accounts } = useMsal();
  const [profilePhoto, setProfilePhoto] = useState(null);
  const [isInitialized, setIsInitialized] = useState(false);
  const tenantId = process.env.REACT_APP_AUTH_TENENT_ID;

  useEffect(() => {
    if (instance && instance.getAllAccounts().length > 0) {
      setIsInitialized(true);
    }
  }, [instance]);

  useEffect(() => {
    const fetchProfilePhoto = async () => {
      if (!isInitialized || !accounts || accounts.length === 0) {
        console.log("MSAL not initialized or no active account found");
        return;
      }

      try {
        const account = getAccountByTenantId(accounts, tenantId);
        const response = await instance.acquireTokenSilent({
          scopes: ["User.Read"],
          account: account
        });
        
        const photoResponse = await fetch("https://graph.microsoft.com/v1.0/me/photo/$value", {
          headers: {
            Authorization: `Bearer ${response.accessToken}`
          }
        });
        
        if (photoResponse.ok) {
          const blob = await photoResponse.blob();
          setProfilePhoto(URL.createObjectURL(blob));
        }
      } catch (error) {
        console.error("Failed to fetch profile photo:", error);
      }
    };

    if (isInitialized) {
      fetchProfilePhoto();
    }
  }, [instance, accounts, isInitialized, tenantId]);

  const handleLogout = () => {
    if (!isInitialized) {
      console.error("MSAL not initialized");
      return;
    }
    
    instance.logoutPopup().catch(error => {
      console.error("Logout failed:", error);
    });
  };

  const account = getAccountByTenantId(accounts, tenantId);

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
      <Avatar
        src={profilePhoto}
        alt={account?.name}
        sx={{ width: 40, height: 40 }}
      />
      <Tooltip title="Sign Out">
        <IconButton onClick={handleLogout} color="primary">
          <LogoutIcon />
        </IconButton>
      </Tooltip>
    </Box>
  );
}

export default SignOut; 